import { ref } from 'vue'

// 按会员令牌隔离场馆和返水，退出或切换账号后丢弃旧请求结果。
export function useMemberVenues({ getToken, fetchVenues }) {
  const venues = ref([])
  const loading = ref(false)
  let ownerToken = ''
  let version = 0
  let pending = null

  function clear() {
    version += 1
    ownerToken = ''
    pending = null
    venues.value = []
    loading.value = false
  }

  function load() {
    const token = getToken()
    if (!token) {
      clear()
      return Promise.resolve([])
    }
    if (pending?.token === token) return pending.promise
    if (ownerToken !== token) venues.value = []
    ownerToken = token
    const requestVersion = ++version
    const request = { token, promise: null }
    const isCurrent = () => requestVersion === version && token === getToken()
    loading.value = true
    pending = request
    request.promise = (async () => {
      try {
        const rows = await fetchVenues()
        if (!isCurrent()) return null
        venues.value = Array.isArray(rows) ? rows : []
        return venues.value
      } catch (error) {
        if (!isCurrent()) return null
        venues.value = []
        throw error
      } finally {
        if (pending === request) {
          pending = null
          loading.value = false
          if (token !== getToken()) {
            ownerToken = ''
            venues.value = []
          }
        }
      }
    })()
    return request.promise
  }

  return { venues, loading, load, clear }
}
